export class TestSms {
    title: string;
    message: string;
    messageWithLineBreaks: string;
    recipientFirstName: string;
    recipientName: string;
    recipientNumber: string;
}
